import { useEffect, useState, useContext } from 'react';
import { getTranslation, useTranslation } from 'utils/localization';
import { Option } from 'components/interfaces/GeneralInterface';
import { GlobalContext } from 'pages/_app';
import { getLanguagesList } from 'services/list.service';
import { TNamespaceEnum } from 'types/types';

export const useLanguagesList = (load = true, reload = false): Option[] => {
    const { t } = useTranslation();
    const [languagesList, setLanguagesList] = useState<Option[]>([]);
    const { lang } = useContext(GlobalContext);

    useEffect(() => {
        if (load && (!languagesList.length || reload)) {
            getLanguagesList().then((r) => {
                const list = [
                    {
                        value: 'CES',
                        label: getTranslation(
                            t,
                            TNamespaceEnum.languages,
                            'CES'
                        ),
                    },
                    ...r.data.values
                        .map((item) => ({
                            value: item.name,
                            label: getTranslation(
                                t,
                                TNamespaceEnum.languages,
                                item.name
                            ),
                        }))
                        .filter((a) => a.value !== 'CES')
                        .sort((a, b) => a.label.localeCompare(b.label)),
                ];
                setLanguagesList(list);
            });
        }
    }, [load, reload]);

    useEffect(() => {
        const langList = languagesList.map((option) => ({
            value: option.value,
            label: getTranslation(
                t,
                TNamespaceEnum.languages,
                option.value as string
            ),
        }));
        setLanguagesList(langList);
    }, [lang]);

    return languagesList;
};
